import React from "react";
import classes from "./OurProjects.module.scss";
import { IProject } from "./OurProjects";
import rightArrowIcon from "../../media/icons/arrowRightBlack.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ProjectItem = ({
  imgUrl,
  title,
  description,
  path,
                       isStartup
}): React.FC<IProject> => {
  const { t } = useTranslation();

  return (
      <Link to={path} className={classes.container}>
        <div className={classes["project-item"]}>
          <div className={classes["project-image-container"]}>
            <img
              src={imgUrl}
              alt={title}
              className={classes["project-image"]}
            />
          </div>
          <h3 className={classes["project-title"]}>{title}</h3>
            {!!isStartup && <div className={classes['startup--wrapper']}><span className={classes.startup}>{t("ourProjects.startup")}</span></div>}
          <p className={classes["project-description"]}>{description}</p>
          <span className={classes["project-link"]}>
            {t("buttons.learnMore")} <img src={rightArrowIcon} alt="Arrow icon" />
          </span>
        </div>
      </Link>
  );
};

export default ProjectItem;
